import { Box } from '@mui/material';
import { To } from 'react-router';

type SideSubMenu = {
  id: string;
  name: string;
  to: To;
  activePathPrefixes?: string[];
};

export type TreeGroupItem = {
  id: string;
  name: string;
  subMenus: SideSubMenu[];
};

export type TreeGroupProps = {
  treeGroupItem: TreeGroupItem;
  selectedMenuItemId: string | null;
  onSelectMenuItem: (menuItemId: string) => void;
  navigate: (to: To) => void;
};

const headingSx = {
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingY: '4px',
  marginX: '16px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  color: '#6B7280',
  borderBottom: '1px solid #D1D5DB',
};

const menuSx = {
  boxSizing: 'border-box',
  border: 'none',
  textAlign: 'left',
  paddingY: '8px',
  paddingLeft: '24px',
  paddingRight: '16px',
  background: 'transparent',
  cursor: 'pointer',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '28px',
  color: '#111827',
};

export const TreeGroup = ({ treeGroupItem, selectedMenuItemId, onSelectMenuItem, navigate }: TreeGroupProps) => {
  const handleSelectMenuItem = (menuItem: SideSubMenu) => {
    onSelectMenuItem(menuItem.id);
    navigate(menuItem.to);
  };
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Box sx={headingSx}>{treeGroupItem.name}</Box>

      {treeGroupItem.subMenus.map((subMenu) => {
        const isSelected = selectedMenuItemId === subMenu.id;
        return (
          <Box key={subMenu.id} sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Box
              component="button"
              onClick={() => handleSelectMenuItem(subMenu)}
              sx={{
                ...menuSx,
                background: isSelected ? '#E0F4FF' : 'transparent',
                color: isSelected ? '#007CC2' : '#111827',
                fontWeight: isSelected ? 600 : 400,
              }}
            >
              {subMenu.name}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
